import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ConfigMaster, ConfigMasterResponse, NSIvoice, PPSOPriceResponse, UserNetSuit, UserNetSuitResponse, UserNMIKeys, UserNMIKeysResponse } from '../models/configMaster.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';
import { Holiday, Holidays, HolidayYear } from '../models/document.model';



@Injectable()
export class ConfigMasterService {
  private baseUrl: string;
  private api: string = "api/ConfigMaster";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  private handleErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
      console.error('Congiguration Master Client Side Error: ', errorResponse.error.message);
    } else {
      throw errorResponse;
    }
  }

  async getConfigMasterAsync(encryptedUser: string): Promise<ConfigMasterResponse | void> {
    const a = await this.httpClient
      .get<ConfigMasterResponse>(`${this.baseUrl}/ConfigMaster_Get/`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "", encryptedUser, "ConfigMasterService", "getConfigMasterAsync"); });

    return a;
  }

  async ConfigMaster_UpdateAsync(encryptedUser: string, configMasterResponse: ConfigMasterResponse): Promise<ConfigMasterResponse | void> {
    const a = await this.httpClient.post<ConfigMasterResponse>(`${this.baseUrl}/ConfigMaster_Update`, configMasterResponse, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, configMasterResponse, "", encryptedUser, "ConfigMasterService", "ConfigMaster_UpdateAsync"); });


    return a;
  }

  async getPPSOPriceAsync(encryptedUser: string): Promise<PPSOPriceResponse | void> {
    const a = await this.httpClient
      .get<PPSOPriceResponse>(`${this.baseUrl}/PPSOPrice_Get/`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "", encryptedUser, "ConfigMasterService", "getPPSOPriceAsync"); });


    return a;
  }

  async PPSOPriceUpdateAsync(encryptedUser: string, id: number, ParamVal: number, UserId: string): Promise<PPSOPriceResponse | void> {
    const a = await this.httpClient.post<PPSOPriceResponse>(`${this.baseUrl}/PPSOPrice_Update/${id}/${ParamVal}/${UserId}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "id - " + id + " ParamVal - " + ParamVal + " UserId - " + UserId, encryptedUser, "ConfigMasterService", "PPSOPriceUpdateAsync"); });


    return a;
  }

  async getUserNMIKeysAsync(encryptedUser: string, CLPUserId: number): Promise<UserNMIKeys | void> {
    const a = await this.httpClient
      .get<UserNMIKeysResponse>(`${this.baseUrl}/UserNMIKeys_Get/${CLPUserId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "CLPUserId -" + CLPUserId, encryptedUser, "ConfigMasterService", "getUserNMIKeysAsync"); });

    return a;
  }

  async getUserNMIKeysAllAsync(encryptedUser: string): Promise<UserNMIKeysResponse | void> {
    const a = await this.httpClient
      .get<UserNMIKeysResponse>(`${this.baseUrl}/UserNMIKeys_Get_All/`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "", encryptedUser, "ConfigMasterService", "getUserNMIKeysAllAsync"); });

    return a;
    }

    async getUserNetSuitAllAsync(encryptedUser: string): Promise<UserNetSuitResponse | void> {
        const a = await this.httpClient
            .get<UserNetSuitResponse>(`${this.baseUrl}/UserNetSuit_Get_All/`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "", encryptedUser, "ConfigMasterService", "UserNetSuit_Get_All"); });

        return a;
    }

  async userNMIKeys_UpdateAsync(encryptedUser: string, userNMIKeys: UserNMIKeys): Promise<UserNMIKeys | void> {
    const a = await this.httpClient.post<UserNMIKeys>(`${this.baseUrl}/UserNMIKeys_Update`, userNMIKeys, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, userNMIKeys, "", encryptedUser, "ConfigMasterService", "ConfigMaster_UpdateAsync"); });


    return a;
    }

    async userNetSuit_UpdateAsync(encryptedUser: string, userNetSuit: UserNetSuit): Promise<UserNetSuit | void> {
        const a = await this.httpClient.post<UserNetSuit>(`${this.baseUrl}/UserNetSuit_Update`, userNetSuit, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, userNetSuit, "", encryptedUser, "ConfigMasterService", "userNetSuit_UpdateAsync"); });


        return a;
    }

    async holiday_CreateAsync(encryptedUser: string, holidayData: Holiday): Promise<Holiday | void> {
        const a = await this.httpClient.post<Holiday>(`${this.baseUrl}/Holiday_Create`, holidayData, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, holidayData, "", encryptedUser, "ConfigMasterService", "holiday_CreateAsync"); });


        return a;
    }

    async getHolidayYear(encryptedUser: string): Promise<HolidayYear[] | void> {
        const a = await this.httpClient
            .get<HolidayYear[]>(`${this.baseUrl}/GetHolidayYear`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "configMasterService", "getHolidayYear"); });

        return a;
    }

    async getUPNSInvoiceAsync(encryptedUser: string, _bojIV: NSIvoice): Promise<NSIvoice[] | void> {
        const a = await this.httpClient
            .post<NSIvoice[]>(`${this.baseUrl}/GetNSIvoiceList/`, _bojIV, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "", encryptedUser, "ConfigMasterService", "getUPNSInvoiceAsync"); });

        return a;
    }

}
